import { isEmpty } from '@aipb/shared/util/other';

export function baseUrl(): string {
  const baseURI = document.baseURI;

  if (!baseURI.endsWith('/')) return baseURI;

  return baseURI.substring(0, baseURI.length - 1);
}

export function stringifyQueryParams(queryParams?: Record<never, never>): string {
  if (!queryParams || isEmpty(queryParams)) return '';

  if (Object.keys(queryParams).filter((key) => queryParams[key]).length === 0) return '';

  return `?${Object.keys(queryParams)
    .filter((key) => queryParams[key])
    .map((key) => `${key}=${encodeURIComponent(queryParams[key])}`)
    .join('&')}`;
}

export function pathWithParams(path: string[], params: Record<any, any>, shouldEncode = false): string[] {
  if (!path) return [];

  let newPath = path;

  for (const key of Object.keys(params)) {
    newPath = newPath.map((p) => p.replace(':' + key, shouldEncode ? encodeURI(params[key]) : params[key]));
  }

  return newPath;
}

export function openUrl(url: string, target = '_blank'): Window | null {
  return window.open(url, target);
}
